import { React, useState, useEffect } from "react";

const PopUpAmAkAnResults = ({ resultsData, catMid, marketType }) => {
    const resultData = resultsData;

    useEffect(() => {
        console.log("Market Type:", marketType);
        console.log("Results Data:", resultsData);
    }, [resultsData, marketType]);

    const dataObj = resultsData;

    const formatMarketStartTime = (dateString) => {
        if (!dateString) return "";
        const date = new Date(dateString);
        if (isNaN(date.getTime())) return "";
        return date.toLocaleString("en-US", {
            month: "numeric",
            day: "numeric",
            year: "numeric",
            hour: "numeric",
            minute: "2-digit",
            second: "2-digit",
            hour12: true
        });
    };

    let Amar = "";
    let Akbar = "";
    let Anthony = "";

    let isRedWinner = "";
    let isBlackWinner = "";

    let isUnderWinner = "";
    let isOverWinner = "";

    let isEvenWinner = "";
    let isOddWinner = "";


    if (marketType == 23) {
        if (resultData?.result == 1) {
            Amar = "Winner";
            Akbar = "LOSER";
            Anthony = "LOSER";
        } else if (resultData?.result == 2) {
            Amar = "LOSER";
            Akbar = "Winner";
            Anthony = "LOSER";
        } else if (resultData?.result == 3) {
            Amar = "LOSER";
            Akbar = "LOSER";
            Anthony = "Winner";
        }
        let card = resultData.c1;

        if (card !== "") {
            const lastTwoChars = card.slice(-2);
            if (lastTwoChars == "CC" || lastTwoChars == "HH") {
                isRedWinner = "LOSER";
                isBlackWinner = "Winner";
            } else {
                isRedWinner = "Winner";
                isBlackWinner = "LOSER";
            }

            const firstTwoChars = card.slice(0, -2);
            let numberVal = firstTwoChars;
            if (firstTwoChars == "J") {
                numberVal = 11;
            } else if (firstTwoChars == "Q") {
                numberVal = 12;
            } else if (firstTwoChars == "K") {
                numberVal = 13;
            }

            if (numberVal == 7) {
                isUnderWinner = false;
                isOverWinner = false;
            } else if (numberVal > 7) {
                isUnderWinner = false;
                isOverWinner = true;
            } else {
                isUnderWinner = true;
                isOverWinner = false;
            }

            if (numberVal % 2 === 0) {
                isEvenWinner = true;
                isOddWinner = false;
            } else {
                isEvenWinner = false;
                isOddWinner = true;
            }
        }
    }

    return (
        <div>
            <div id="ResultsData">
                <div class="left-content site_family">

                    <div id="AAA" style={{ display: marketType == 23 ? "" : "none" }}>
                        <div class="left-content">
                            <div class="card">
                                <div class="card-header">
                                    {dataObj.round_od} - (<b>Round Id = </b> {catMid})
                                </div>
                                <div class="card-body">
                                    <div className="aaa-community-section">
                                        <div className="aaa-community-title">
                                            Community Card
                                        </div>
                                        <div className="aaa-community-box">
                                            <img
                                                src={`/assets/images/cards/${resultData.c1}.svg`}
                                                className="aaa-community-card"
                                                alt="Community Card"
                                            />
                                        </div>
                                    </div>
                                    <div>
                                        <div class="market-runners">
                                            <div class="runner-runner">
                                                <h3 class="runner-name">
                                                    <div class="runner-info">
                                                        <span class="clippable runner-display-name">
                                                            <h4
                                                                data-toggle="tooltip"
                                                                data-placement="top"
                                                                data-html="true"
                                                                class="clippable-spacer"
                                                            >
                                                                Amar
                                                            </h4>
                                                        </span>
                                                    </div>
                                                </h3>
                                                <div class="runner-disabled">{Amar}</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div>
                                        <div class="market-runners">
                                            <div class="runner-runner">
                                                <h3 class="runner-name">
                                                    <div class="runner-info">
                                                        <span class="clippable runner-display-name">
                                                            <h4
                                                                data-toggle="tooltip"
                                                                data-placement="top"
                                                                data-html="true"
                                                                class="clippable-spacer"
                                                            >
                                                                Akbar
                                                            </h4>
                                                        </span>
                                                    </div>
                                                </h3>
                                                <div class="runner-disabled">{Akbar}</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div>
                                        <div class="market-runners">
                                            <div class="runner-runner">
                                                <h3 class="runner-name">
                                                    <div class="runner-info">
                                                        <span class="clippable runner-display-name">
                                                            <h4
                                                                data-toggle="tooltip"
                                                                data-placement="top"
                                                                data-html="true"
                                                                class="clippable-spacer"
                                                            >
                                                                Anthony
                                                            </h4>
                                                        </span>
                                                    </div>
                                                </h3>
                                                <div class="runner-disabled">{Anthony}</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div>
                                        <div class="market-runners">
                                            <div class="runner-runner">
                                                <h3 class="runner-name">
                                                    <div class="runner-info">
                                                        <span class="clippable runner-display-name">
                                                            <h4
                                                                data-toggle="tooltip"
                                                                data-placement="top"
                                                                data-html="true"
                                                                class="clippable-spacer"
                                                            >
                                                                Odd
                                                            </h4>
                                                        </span>
                                                    </div>
                                                </h3>
                                                <div class="runner-disabled">LOSER</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div>
                                        <div class="market-runners">
                                            <div class="runner-runner">
                                                <h3 class="runner-name">
                                                    <div class="runner-info">
                                                        <span class="clippable runner-display-name">
                                                            <h4
                                                                data-toggle="tooltip"
                                                                data-placement="top"
                                                                data-html="true"
                                                                class="clippable-spacer"
                                                            >
                                                                Even
                                                            </h4>
                                                        </span>
                                                    </div>
                                                </h3>
                                                <div class="runner-disabled">WINNER</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div>
                                        <div class="market-runners">
                                            <div class="runner-runner">
                                                <h3 class="runner-name">
                                                    <div class="runner-info">
                                                        <span class="clippable runner-display-name">
                                                            <h4
                                                                data-toggle="tooltip"
                                                                data-placement="top"
                                                                data-html="true"
                                                                class="clippable-spacer"
                                                            >
                                                                Black
                                                            </h4>
                                                        </span>
                                                    </div>
                                                </h3>
                                                <div class="runner-disabled">{isBlackWinner}</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div>
                                        <div class="market-runners">
                                            <div class="runner-runner">
                                                <h3 class="runner-name">
                                                    <div class="runner-info">
                                                        <span class="clippable runner-display-name">
                                                            <h4
                                                                data-toggle="tooltip"
                                                                data-placement="top"
                                                                data-html="true"
                                                                class="clippable-spacer"
                                                            >
                                                                Red
                                                            </h4>
                                                        </span>
                                                    </div>
                                                </h3>
                                                <div class="runner-disabled">{isRedWinner}</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div>
                                        <div class="market-runners">
                                            <div class="runner-runner">
                                                <h3 class="runner-name">
                                                    <div class="runner-info">
                                                        <span class="clippable runner-display-name">
                                                            <h4
                                                                data-toggle="tooltip"
                                                                data-placement="top"
                                                                data-html="true"
                                                                class="clippable-spacer"
                                                            >
                                                                Under 7
                                                            </h4>
                                                        </span>
                                                    </div>
                                                </h3>
                                                <div class="runner-disabled">WINNER</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div>
                                        <div class="market-runners">
                                            <div class="runner-runner">
                                                <h3 class="runner-name">
                                                    <div class="runner-info">
                                                        <span class="clippable runner-display-name">
                                                            <h4
                                                                data-toggle="tooltip"
                                                                data-placement="top"
                                                                data-html="true"
                                                                class="clippable-spacer"
                                                            >
                                                                Over 7
                                                            </h4>
                                                        </span>
                                                    </div>
                                                </h3>
                                                <div class="runner-disabled">LOSER</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <style>
                {`

        .card-body {
            width: 100%;
            box-sizing: border-box;
        }
        .aaa-community-section {
            width: 100%;
            display: flex;
            flex-direction: column;
            align-items: center;
            text-align: center;
            margin-bottom: 20px;
        }
        .aaa-community-title {
            width: 100%;
            text-align: center;
            font-size: 24px;
            font-weight: 700;
            margin-bottom: 8px;
        }
        .aaa-community-box {
            width: calc(100% - 40px);
            border: 1px solid #c8ddc8;
            border-radius: 20px;
            display: flex;
            align-items: center;
            justify-content: center;
            box-sizing: border-box;
            padding: 4px;
        }
        .aaa-community-card {
            display: block;
            width: 50px;
            max-width: 85px;
            height: auto;
            margin: 0 auto;
        }
        .market-runners {
            width: 100%;
            display: flex;
            justify-content: center;
        }
        .runner-runner {
            width: 100%;
            height: 55px;
            margin-top: 2px;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            text-align: center;
            border-radius: 2px;
            transition: background-color .25s ease-out;
        }
        .runner-name {
            width: 100%;
            margin: 0;
            padding: 0;
            text-align: center;
            font-size: 30px;
            line-height: 35px;
        }
        .runner-info {
            width: 100%;
            text-align: center;
        }
        .runner-display-name {
            width: 100%;
            display: block;
            text-align: center;
        }
        .clippable-spacer {
            width: 100%;
            margin: 0;
            padding: 0;
            text-align: center;
        }
        .runner-disabled {
            width: 100%;
            line-height: 40px;
            color: #000;
            background: transparent;
            text-align: center;
            text-transform: uppercase;
            margin-top: -3px;
        }
        .cards {
            border: none !important;
            background: transparent !important;
            box-shadow: none !important;
            padding: 0 !important;
            margin: 0 !important;
        }

    `}
            </style>
        </div>
    );
};

export default PopUpAmAkAnResults;

